'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalBody = function ModalBody(props) {
    var theme = props.theme,
        className = props.className,
        children = props.children;

    if (!theme) {
        return null;
    }

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(theme.modalBody, className) },
        children
    );
};

exports.default = ModalBody;


//////////////////
// WEBPACK FOOTER
// ./~/dibs-elements/lib/ModalBody/index.js
// module id = 856
// module chunks = 4 5 8 9 14